import { CustomerGroupResponse } from "@/models/response/customerGroup";
import customerGroupService from "@/services/customerGroup";
import useMessageStore, { MessageGroupType, MessageType } from "@/store/message";
import { useNavigate } from "react-router-dom";

export const GROUPS_PATH = "/dashboard/profile/customerGroup";
export const membersPath = (id?: number, openAdd?: boolean) => `${GROUPS_PATH}/members?id=${id ?? 0}${openAdd ? "&add=1" : ""}`;

// Starts "پیامک به مشتریان" with this group already chosen as the audience.
export function useSendToGroup() {
  const setCustomers = useMessageStore((state) => state.setCustomers);
  const navigate = useNavigate();
  return (group: CustomerGroupResponse) => {
    setCustomers({
      type: MessageType.messageGroup,
      groupType: MessageGroupType.customerGroup,
      customerGroup: group,
      discountGroup: undefined,
      discountGroupCount: group.membersCount,
      customers: [],
    });
    navigate("/dashboard/messages/selectUser");
  };
}

// There is no get-by-id endpoint; group names are unique per salon, and the list is short.
export async function findGroup(match: (group: CustomerGroupResponse) => boolean, term = "") {
  const page = await customerGroupService.getCustomerGroups({ Count: 500, Skip: 0, Term: term });
  return page.result?.find(match);
}

// Closing through history drops the sheet's #hash entry; the drawer then closes itself.
export function closeSheet(name: string, close: () => void) {
  if (window.location.hash === `#${name}`) window.history.back();
  else close();
}
